import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth ,firestore} from "../firebase/firebase"; // Make sure the path is correct
import { IoIosLogOut } from "react-icons/io"; // Import the logout icon
import { doc, updateDoc } from "firebase/firestore";


const LogoutButton = () => {
  const navigate = useNavigate();

  // const handleLogout = async () => {
  //   try {
  //     await signOut(auth); // Firebase signOut method to log the user out
  //     console.log("User successfully logged out.");

  //     // Redirect to login page after successful logout
  //     navigate("/");
  //   } catch (err) {
  //     console.error("Error logging out:", err);
  //   }
  // };


  const handleLogout = async () => {
    try {
      const currentUser = auth.currentUser;

      if (currentUser) {
        // Get the user's Firestore document reference
        const userDocRef = doc(firestore, "users", currentUser.uid);

        // Update the Firestore document to set isLoggedIn to false
        await updateDoc(userDocRef, {
          isLoggedIn: false,
          token: null, // Optionally, clear the token field
        });

        console.log("Firestore updated: User is logged out.");

        // Firebase signOut method to log the user out
        await signOut(auth);
        console.log("User successfully logged out.");

        // Redirect to login page after successful logout
        navigate("/");
      }
    } catch (err) {
      console.error("Error logging out:", err);
    }
  };
  return (
    <IoIosLogOut
      className="w-20 h-8 text-blue-800 hover:text-blue-950 transition duration-300 cursor-pointer mt-2 "
      onClick={handleLogout}
    />
  );
};

export default LogoutButton;
